import * as React from 'react'

import { ReviewElementWithFeatures } from '@thg-commerce/enterprise-network/src/transformers/product/reviews'

import { FeatureRatingRectangles } from '../FeatureRatingRectangles'

export type FeatureRatingDisplayProps = {
  featureRatings: ReviewElementWithFeatures[]
}

export const FeatureRatingDisplay = (props: FeatureRatingDisplayProps) => {
  const createFeatureRatingGroup =
    props.featureRatings.length > 0 &&
    props.featureRatings.map((reviewElement, index) => {
      return reviewElement.feature && reviewElement.score ? (
        <FeatureRatingRectangles
          key={index}
          featureRatingState={reviewElement.score}
          featureRatingType={
            reviewElement.feature.hasDefaultMeasurement ? 'scale' : 'default'
          }
          displayOnly={true}
          featureRatingName={reviewElement.key}
          maxRectangles={reviewElement.maxScore}
          measurementLabels={reviewElement.feature.measurementValues.map(
            (measurement) => measurement.label,
          )}
        />
      ) : null
    })

  return <React.Fragment>{createFeatureRatingGroup}</React.Fragment>
}
